/*
 * File: CurrentAppointmentDetailList.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows and styles the list of details (provider, resource, notes, etc) of the currently selected appointment
 */
import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { format } from "date-fns";

const styles = theme => ({
  root: {
    position: "relative",
    width: "100%"
  },
  titleText: {
    fontWeight: 500,
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(1.5)
  },
  dateText: {
    fontWeight: 500,
    marginBottom: theme.spacing(1)
  }
});

const CurrentAppointmentDetailList = ({ appt, classes }) => {

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.titleText}>
        {format(appt.startTime, "MMMM do, yyyy")}
      </Typography>
      <Typography variant="h6" className={classes.dateText}>
        {format(appt.startTime, "h:mm a") + " (" + appt.length + " Min)"}
      </Typography>
      <div>
        <Typography>
          <b>Provider:</b> {appt.providerID > 1 ? appt.providerName : "None"}
        </Typography>
        <Typography>
          <b>Resource:</b> {appt.resource}
        </Typography>
        <Typography>
          <b>Type:</b> {appt.type}
        </Typography>
        <Typography>
          <b>Status:</b> {appt.status}
        </Typography>
        <Typography>
          <b>Notes:</b> {appt.notes}
        </Typography>
      </div>
    </div>
  );
};

CurrentAppointmentDetailList.propTypes = {
  appt: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(CurrentAppointmentDetailList));
